export enum CallState {
    INACTIVE = "INACTIVE",
    ACTIVE = "ACTIVE",
    INCOMING = "INCOMING",
    CONNECTING = "CONNECTING"
}


